import React from 'react';
import ReactDOM from 'react-dom/client';
import { StandaloneApp } from './offer-analysis-workspace';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <StandaloneApp />
);
